/**
 * @name setDrawerButton
 * @description ドロワーナビの開閉
 * @param {Object} lenis -lenis.jsのインスタンス
 */
class setDrawerButton {
    constructor() {
        // this.lenis = lenis;
        this.html = document.querySelector('html');
        this.drawerNav = document.querySelector('.drawerNav');
        this.drawerButton = document.querySelectorAll('.drawerButton');
        this.links = document.querySelectorAll('a[data-anchor="true"]');
        this.__init();
    }

    /**
     * @name init
     * @description 初期処理
     */
    __init() {
        if (this.drawerButton === null) return;
        // ドロワーボタンクリック時
        this.drawerButton.forEach((button) => button.addEventListener("click", () => this.__toggle()));

        // アンカーリンククリック時
        this.links.forEach((link) => link.addEventListener("click", () => this.__toggle()));

        //「ESC」キー押下時
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && this.html.dataset.state === "navOpen") this.__toggle();
        });

        // ドロワーナビゲーションのスクロールを無効化
        if (this.drawerNav) {
            this.drawerNav.addEventListener('wheel', (e) => e.stopPropagation(), { passive: false })
            this.drawerNav.addEventListener('touchmove', (e) => e.stopPropagation(), { passive: false })
        }
    }

    /**
     * @name toggle
     * @description ドロワーナビの開閉
     */
    __toggle() {
        this.html.dataset.state = this.html.dataset.state === "navOpen" ? "" : "navOpen";
        // this.html.dataset.state === "navOpen" ? this.lenis.stop() : this.lenis.start();
    }
}

export default setDrawerButton;